import { ThisConnector } from '../../../api/connector'
import { Query } from '../../../hooks/queries'
import { useContrastQuery } from '../../../hooks/use-contrast-query'

interface AgentKeyArgs {
  orgUuid: string
  filterText?: string
  pageIndex?: number
  pageSize?: number
}

export interface AgentsResource {
  id: string
  uid: string
  firstName: string
  signupDate: Date
  lastLoginTime: Date
}

interface ApiResponse {
  success: boolean
  messages: string[]
  agents: AgentsResource[]
  total: number
}

export async function getOrganizationAgents(
  this: ThisConnector,
  { orgUuid, filterText, pageIndex, pageSize }: AgentKeyArgs
) {
  const queryParams = new URLSearchParams()

  if (filterText) {
    queryParams.append('filterText', filterText)
  }
  if (pageIndex !== undefined) {
    queryParams.append('offset', pageIndex.toString())
  }
  if (pageSize !== undefined) {
    queryParams.append('limit', pageSize.toString())
  }

  const url = `/organizations/${orgUuid}/agents?${queryParams.toString()}`

  return this.connector.get(url)
}

export const useOrganizationAgents = ({
  orgUuid,
  filterText,
  pageIndex,
  pageSize
}: AgentKeyArgs) => {
  const { isLoading, error, data, refetch } = useContrastQuery<
    AgentKeyArgs,
    ApiResponse
  >(
    [Query.AGENT_CONFIG, orgUuid, filterText ?? '', pageIndex, pageSize],
    getOrganizationAgents,
    {
      orgUuid,
      filterText,
      pageIndex,
      pageSize
    }
  )

  return {
    isLoading,
    error,
    data,
    refetch: async () => {
      await refetch()
    }
  }
}
